import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { getPayerEngagementsWorkDefinitions } from "../../../services/payerEngagements/getPayerEngagementWorkDefinitions";

export const QUERY_ENGAGEMENT_WORK_DEFINITIONS =
  "QUERY_ENGAGEMENT_WORK_DEFINITIONS";

export const useQueryEngagementsWorkDefinitions = (
  params: { payerId: string; engagementId: string },
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof getPayerEngagementsWorkDefinitions>>,
    WSServiceError
  >
) =>
  useWSQuery(
    [QUERY_ENGAGEMENT_WORK_DEFINITIONS, params],
    () => getPayerEngagementsWorkDefinitions(params, {}),
    config
  );
